import { TDynamicForm, TDynamicFormField } from "../../form-elements/dynamic-form/dynamic-form";

const sharedFields = [
  {
    type: "text",
    name: "subject",
    label: "Ämne",
    rules: { required: true },
  },
  {
    type: "textarea",
    name: "description",
    label: "Beskriv ditt ärende",
    rules: { required: true },
    maxLength: 1000,
  },
  {
    type: "text",
    name: "firstName",
    label: "Förnamn",
    autoComplete: "given-name",
    rules: { required: true },
  },
  {
    type: "text",
    name: "lastName",
    label: "Efternamn",
    autoComplete: "family-name",
    rules: { required: true },
  },
  {
    type: "text",
    name: "email",
    label: "E-post",
    autoComplete: "email",
    rules: { required: true },
  },
  {
    type: "text",
    name: "phone",
    label: "Telefonnummer eller mobil",
    autoComplete: "tel",
    rules: { required: true },
  },
  {
    type: "fileupload",
    name: "attachedFiles",
    label: "Bifoga filer",
    helperText: "Bifoga filer som hjälper oss att hjälpa dig.",
    allowMultipleFiles: true,
  },
  {
    type: "checkbox",
    name: "termsAccepted",
    label: "Villkor",
    rules: { required: true },
    checkboxes: [
      {
        name: "termsAccepted",
        value: "true",
        label: "Jag samtycker härmed till att Preem AB behandlar mina personuppgifter enligt ovan",
      },
    ],
  },
] satisfies Array<TDynamicFormField>;

const addressChangeForm: TDynamicForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "heading",
      value: <h5>Adressändring</h5>,
    },
    {
      type: "select",
      name: "subCategory",
      label: "Underkategori",
      rules: { required: true },
      items: [
        {
          label: "Alternativ fakturaadress",
          value: "Alternativ fakturaadress",
        },
        {
          label: "Företaget har flyttat",
          value: "Företaget har flyttat",
        },
        {
          label: "Personalkort",
          value: "Personalkort",
        },
      ],
    },
    {
      type: "content",
      name: "alternativ-fakturaadress-content",
      value: (
        <p className={"body-base"}>
          Vi rekommenderar att fakturorna går till företagets bokföringsadress. Se gärna våra digitala fakturaalternativ
          istället.
        </p>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Alternativ fakturaadress"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "content",
      name: "foretag-flyttat-content",
      value: (
        <p className={"body-base"}>
          För att vi ska kunna ändra adress behöver den nya adressen vara registrerad hos bolagsverket.
        </p>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Foretaget har flyttat"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "content",
      name: "personalkort-content",
      value: (
        <p className={"body-base"}>
          Uppge kortnummer, har du flera kort ange alla kortnummer, samt din nya adress och när den börjar gälla.
        </p>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Personalkort"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "text",
      name: "cardNumber",
      label: "Kortnummer",
      renderCondition: {
        dependency: new Map([["subCategory", ["Personalkort"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "text",
      name: "customerNumber",
      label: "Kund- eller organisationnummer",
      renderCondition: {
        dependency: new Map([["subCategory", ["Alternativ fakturaadress", "Foretaget har flyttat"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
      rules: { required: true },
    },
    ...sharedFields.filter((field) => field.name !== "subject"),
  ],
};

const appsForm: TDynamicForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "heading",
      value: <h5>Appar</h5>,
    },
    ...sharedFields,
  ],
};

const fakturaForm: TDynamicForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "heading",
      value: <h5>Faktura</h5>,
    },
    {
      type: "select",
      name: "subCategory",
      label: "Underkategori",
      rules: { required: true },
      items: [
        {
          label: "Autogiro",
          value: "Payment#1",
        },
        {
          label: "E-faktura",
          value: "Digital invoice#1",
        },
        {
          label: "Faktura som PDF",
          value: "Digital invoice#2",
        },
        {
          label: "Fakturakopia",
          value: "Copy of invoice",
        },
        {
          label: "Fel-/dubbelinbetalning",
          value: "Payment#2",
        },
        {
          label: "Påminnelse/krav",
          value: "Reminder",
        },
        {
          label: "Övrig fakturafråga",
          value: "Other",
        },
      ],
    },
    {
      type: "content",
      name: "faktura-autogiro-content",
      value: (
        <>
          <p className={"body-base"}>
            Uppge kortnummer, har du flera kort ange alla kortnummer, samt din nya adress och när Har du enskild firma
            ansöker du om autogiro via din internetbank, andra bolagsformer behöver fylla i en autogiro-blankett och
            skicka till <a href="mailto:edifaktura@preem.se">edifaktura@preem.se</a>.{" "}
            <a href="https://www.preem.se/foretag/vara-kort/faktura/fakturaalternativ/autogiro/">Läs mer här.</a>
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Payment#1"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "content",
      name: "faktura-efaktura-content",
      value: (
        <>
          <p className={"body-base"}>
            Du anmäler E-faktura via din internetbank.{" "}
            <a href="https://www.preem.se/foretag/vara-kort/faktura/fakturaalternativ/e-faktura/">Läs mer här</a>.{" "}
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Digital invoice#1"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "content",
      name: "faktura-pdf-content",
      value: (
        <>
          <p className={"body-base"}>
            Ange vilken e-postadress ni vill ha fakturan på samt vilket kundnummer eller kortnummer som fakturan gäller.
            Vi kommer att bekräfta nya fakturaadressen till adressen ni skriver under e-mail, kan ni inte ta emot
            bekräftelsen på er faktura-mailadress behöver ni ange den under &quot;Beskriv ditt ärende&quot; och mailen
            vi kan kontakta er på i &quot;Email&quot;-fältet.
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Digital invoice#2"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "content",
      name: "faktura-kopia-content",
      value: (
        <>
          <p className={"body-base"}>
            Ange gärna fakturanummer eller period som fakturan ska gälla. Företagets fakturor går även att hitta på
            Preems kundportal. Har du inga inloggningsuppgifter kan du kontakta oss så hjälper vi dig att skapa en
            användare. Som firmatecknare har du möjlighet att logga in direkt med Bank-ID.
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Copy of invoice"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "content",
      name: "faktura-feldubbel-content",
      value: (
        <>
          <p className={"body-base"}>
            Vid fel- eller dubbelinbetalning ber vi er att maila vår reskontraavdelning på{" "}
            <a href="mailto:reskontra@preem.se">reskontra@preem.se</a> eller ring helgfria vardagar mellan 9-11:30 på{" "}
            <a href="tel:010-450 1681">010-450 1681</a>.
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Payment#2"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "content",
      name: "faktura-krav-content",
      value: (
        <>
          <p className={"body-base"}>
            Om du har fått ett kravbrev kan ditt konto vara tillfälligt spärrat. För att återöppna det behöver ni
            kontakta vår kreditavdelning på <a href="tel:010-450 16 70">010-450 16 70</a> helgfria vardagar mellan
            09:00-16:00, stängt för lunch mellan 12:00-13:00.
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Reminder"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "text",
      name: "invoiceNumber",
      label: "Fakturanummer",
      renderCondition: {
        dependency: new Map([["subCategory", ["Payment#2", "Reminder"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "text",
      name: "customerNumber",
      label: "Kund- eller organisationnummer",
      renderCondition: {
        dependency: new Map([["subCategory", ["Other"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
      rules: { required: true },
    },
    ...sharedFields,
  ],
};

const foretagsKortForm: TDynamicForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "heading",
      value: <h5>Företagskort</h5>,
    },
    {
      type: "content",
      name: "foretagskort-content",
      value: (
        <>
          <p className={"body-base"}>
            Du kan hantera dina kort via Preems{" "}
            <a target="_blank" href="https://mitt.preem.se/" rel="noreferrer">
              Kundportal
            </a>
            . Som firmatecknare har du möjlighet att logga in direkt med Bank-ID.
          </p>
        </>
      ),
    },
    {
      type: "select",
      name: "subCategory",
      label: "Underkategori",
      rules: { required: true },
      items: [
        {
          label: "Avsluta konto",
          value: "Close Account",
        },
        {
          label: "Beställ kort",
          value: "Order card",
        },
        {
          label: "Kortlista",
          value: "Information request",
        },
        {
          label: "PIN-kod",
          value: "PIN-Copy",
        },
        {
          label: "Spärra kort",
          value: "Block card",
        },
        {
          label: "Övrigt",
          value: "Other",
        },
      ],
    },
    {
      type: "content",
      name: "",
      value: <p className="mt-0">Du vet väl att du kan se PIN-kod för dina kort inne i Kundportalen?</p>,
      renderCondition: {
        fieldStateUntilConditionMet: "hidden",
        dependency: new Map([["subCategory", ["PIN-Copy"]]]),
      },
    },
    {
      type: "select",
      name: "cardListType",
      label: "Kortlista",
      helperText:
        "Vi kan erbjuda ett antal olika kortlistor, antingen kopplat till kundnummer eller organisationsnummer. Ange vilket samt vilken typ av kortlista som passar er bäst. Du kan även få fram kortlistan själv via Preems Kundportal.",
      rules: { required: true },
      renderCondition: {
        dependency: new Map([["subCategory", ["Information request"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
      items: [
        {
          label: "Aktiva kort de senaste 6 mån",
          value: "aktiva-kort-de-senaste-6-man",
        },
        {
          label: "Samtliga kort (inklusive spärrade)",
          value: "samtliga-kort-inkl-sparrade",
        },
        {
          label: "Endast aktiva kort",
          value: "endast-aktiva-kort",
        },
      ],
    },
    {
      type: "content",
      name: "foretagskort-avsluta-content",
      value: (
        <>
          <p className={"body-base"}>
            Vid avslut kommer vi att stänga ner era kort och ta bort krediten. Om det gäller hela ert engagemang hos
            Preem lägg in organisationsnumret, gäller det enbart ett av era kundnummer, ange det så avslutar vi bara det
            kundnumret. Vid enbart avslut av ett eller flera kort, välj &quot;Spärra kort&quot;.
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Close Account"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "text",
      name: "customerNumber",
      label: "Kund- eller organisationnummer",
      renderCondition: {
        dependency: new Map([["subCategory", ["Close Account", "Order card", "Other"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
      rules: { required: true },
    },
    ...sharedFields,
  ],
};

const ediFakturaForm: TDynamicForm = {
  mode: "onSubmit",
  reValidateMode: "onBlur",
  fields: [
    {
      type: "content",
      name: "content",
      value: (
        <p>
          För att anmäla EDI-faktura så besök gärna vårt egna formulär avsett för det. Formuläret hittar du{" "}
          <a href="/foretag/kundservice/edi-faktura">här.</a>
        </p>
      ),
    },
  ],
};

const kundportalenForm: TDynamicForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "heading",
      value: <h5>Kundportalen</h5>,
    },
    {
      type: "text",
      name: "customerNumber",
      label: "Kund- eller organisationnummer",
      rules: { required: true },
    },
    ...sharedFields,
  ],
};

const productQuestionForm: TDynamicForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "heading",
      value: <h5>Produktfråga</h5>,
    },
    {
      type: "content",
      name: "produktfraga-content",
      value: (
        <>
          <p className={"body-base"}>
            Klicka{" "}
            <a
              target={"_blank"}
              href="https://www.preem.se/foretag/produkt-och-tjanster/Produktkatalog/"
              rel="noreferrer"
            >
              här
            </a>{" "}
            för att komma till vår samlade information om produkter.
          </p>
        </>
      ),
    },

    ...sharedFields,
  ],
};

const stationQuestionForm: TDynamicForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "heading",
      value: <h5>Stationsfråga</h5>,
    },
    {
      type: "select",
      name: "subCategory",
      label: "Underkategori",
      items: [
        {
          label: "Fråga",
          value: "Inquiry",
        },
        {
          label: "Felanmälan",
          value: "Report fault",
        },
        {
          label: "Önskemål",
          value: "Other",
        },
        {
          label: "Övrigt",
          value: "Other",
        },
      ],
    },
    {
      type: "content",
      name: "stationsfraga-felanmalan-content",
      value: (
        <>
          <p className={"body-base"}>
            För att hantera din felanmälan behöver vi veta vilken station, när, samt vid vilken pump problemet uppstod.
            Vänligen förklara så utförligt som möjligt.
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Report fault"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    ...sharedFields,
  ],
};

const statistikForm: TDynamicForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "heading",
      value: <h5>Statistik</h5>,
    },
    {
      type: "select",
      name: "subCategory",
      label: "Underkategori",
      items: [
        {
          label: "Förbrukningsstatistik",
          value: "Purchase stats",
        },
        {
          label: "Miljörapport",
          value: "Environmental stats",
        },
        {
          label: "Övrig statistik",
          value: "Information request",
        },
      ],
    },
    {
      type: "content",
      name: "statistics-forbrukning-content",
      value: (
        <>
          <p className={"body-base"}>
            Vänligen ange kundnummer eller organisationsnummer samt för vilken period ni önskar statistiken. Vi kan få
            fram förbrukningsstatistik för de senaste 3 kalenderåren.
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Purchase stats"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "content",
      name: "statistics-miljorapport-content",
      value: (
        <>
          <p className={"body-base"}>
            Vänligen ange organisationsnummer samt för vilken period ni önskar statistiken. Du kan även få fram din
            miljörapport själv i Preems Kundportal.
          </p>
        </>
      ),
      renderCondition: {
        dependency: new Map([["subCategory", ["Environmental stats"]]]),
        fieldStateUntilConditionMet: "hidden",
      },
    },
    {
      type: "text",
      name: "customerNumber",
      label: "Kund- eller organisationnummer",
      rules: { required: true },
    },
    ...sharedFields,
  ],
};

const otherForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "heading",
      value: <h5>Övrigt</h5>,
    },
    ...sharedFields,
  ],
} satisfies TDynamicForm;

const CompanyForms = {
  addresschange: { label: "Adressändring", form: addressChangeForm },
  apps: { label: "Appar", form: appsForm },
  businesscard: { label: "Företagskort", form: foretagsKortForm },
  invoice: { label: "Faktura", form: fakturaForm },
  edi: { label: "EDI-faktura", form: ediFakturaForm },
  kundportalen: { label: "Kundportalen", form: kundportalenForm },
  product: { label: "Produktfråga", form: productQuestionForm },
  station: { label: "Stationsfråga", form: stationQuestionForm },
  statistik: { label: "Statistik", form: statistikForm },
  other: { label: "Övrigt", form: otherForm },
} satisfies Record<string, TDynamicFormConfig>;

export type TDynamicFormConfig = {
  label: string;
  form: TDynamicForm;
};

export default CompanyForms;
